// JsaHazCom
export class JsaHazCom {
  constructor(data = {}) {
    this.hazComUseYes = data.haz_com_use_yes || false;
    this.hazComUseNo = data.haz_com_use_no || false;
    this.hazComSdsYes = data.haz_com_sds_yes || false;
    this.hazComSdsNo = data.haz_com_sds_no || false;
    this.hazComGasMeterYes = data.haz_com_gas_meter_yes || false;
    this.hazComGasMeterNo = data.haz_com_gas_meter_no || false;
  }

  // Update functions
  updateHazComUseYes(value) {
    // If no value, then everything is set to false
    if (!value) {
      this.hazComUseYes = false;
      this.hazComSdsYes = false;
      this.hazComSdsNo = false;
      this.hazComGasMeterYes = false;
      this.hazComGasMeterNo = false;
    } else {
      this.hazComUseYes = value;
      this.hazComUseNo = false;
    }
  }

  updateHazComUseNo(value) {
    if (!value) {
      this.hazComUseNo = false;
    } else {
      // If yes, then everything is set to false
      this.hazComUseNo = value;
      this.hazComUseYes = false;
      this.hazComSdsNo = false;
      this.hazComSdsYes = false;
      this.hazComGasMeterNo = false;
      this.hazComGasMeterYes = false;
    }
  }

  updateHazComSdsYes(value) {
    if (!value) {
      this.hazComSdsYes = false;
    } else {
      this.hazComSdsYes = value;
      this.hazComSdsNo = false;
    }
  }

  updateHazComSdsNo(value) {
    if (!value) {
      this.hazComSdsNo = false;
    } else {
      this.hazComSdsNo = value;
      this.hazComSdsYes = false;
    }
  }

  updateHazComGasMeterYes(value) {
    if (!value) {
      this.hazComGasMeterYes = false;
    } else {
      this.hazComGasMeterYes = value;
      this.hazComGasMeterNo = false;
    }
  }

  updateHazComGasMeterNo(value) {
    if (!value) {
      this.hazComGasMeterNo = false;
    } else {
      this.hazComGasMeterNo = value;
      this.hazComGasMeterYes = false;
    }
  }

  // To json for sending to the database
  toJson() {
    return {
      haz_com_use_yes: this.hazComUseYes,
      haz_com_use_no: this.hazComUseNo,
      haz_com_sds_yes: this.hazComSdsYes,
      haz_com_sds_no: this.hazComSdsNo,
      haz_com_gas_meter_yes: this.hazComGasMeterYes,
      haz_com_gas_meter_no: this.hazComGasMeterNo,
    };
  }

  // Helper for single and multi-field patches to be sent via websocket
  toPatch(fields, jsaId, action = "update") {
    const fieldMap = {
      hazComUseYes: "haz_com_use_yes",
      hazComUseNo: "haz_com_use_no",
      hazComSdsYes: "haz_com_sds_yes",
      hazComSdsNo: "haz_com_sds_no",
      hazComGasMeterYes: "haz_com_gas_meter_yes",
      hazComGasMeterNo: "haz_com_gas_meter_no",
    };

    const patch = {
      patch_type: "jsa_haz_com",
      jsa_id: jsaId,
      action,
    };

    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        patch[dbField] = value;
      }
    }

    return patch;
  }
}
